import React, { useEffect, useState, useRef } from 'react';
import { Link, generatePath } from 'react-router-dom';
import { Button, Card, Space, Table, TableProps, Tag, Tooltip, Typography, Pagination } from 'antd';
import { EditOutlined, FolderAddOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { documentUtil, onIthAnchorClick } from '@/utils';
import { PPMService, getPMProjectsApi, followPMProjectApi } from '@/services';
import { ProjectHalSource } from '@/halSources';
import { IthHelmet, PpmProjectListRefreshEventName, ProjectStatus, ThEmpty, dispatchPpmProjectUpdateModalOpenEvent } from '@/components';
import ppmLogo from '@/assets/ppm-logo.png';
import styles from "./index.module.scss"
import ProjectHeader, { IFilterParams } from "./header"
import { AddFollowSvg, FollowedSvg } from "@/components/svgs"

const ProjectList: React.FC = () => {
  const [page, setPage] = useState(1)
  const pageSize = useRef(30)
  // const { data, loading, refresh, run: fetchProjects } = useRequest(PPMService.getProjects, {
  //   manual: true,
  // });
  const { data, loading, refresh, run: fetchProjects } = useRequest(getPMProjectsApi, {
    manual: true,
    debounceWait: 300,
    onSuccess: (data) => {
      const set = new Set()
      data.list.forEach(v => {
        if (set.has(v.code)) {
          console.log("key:", v)
        } else {
          set.add(v.code)
        }
      })
    }
  })
  const [filterParams, setFilterParams] = useState<IFilterParams>()
  const [tableOrder, setTableOrder] = useState("")
  const onFilterParamsChange = (v: IFilterParams) => {
    setFilterParams(v)
    setPage(1)
    const params: Req.ProjectParams = {
      ...v,
      page: 1,
      pageSize: pageSize.current,
    }
    fetchProjects(params)
  }
  useEffect(() => {
    setPage(1)
    const params: Req.ProjectParams = {
      page: 1,
      pageSize: pageSize.current,
      businessType: filterParams?.businessType || "",
      projectCategory: filterParams?.projectCategory || "",
      projectBigStage: filterParams?.projectBigStage || "",
      companyCode: filterParams?.companyCode || "",
      deptCode: filterParams?.deptCode || "",
      keyword: filterParams?.keyword || "",
      sort: tableOrder
    }
    fetchProjects(params)
  }, [tableOrder])
  const onPageChange = (v: number) => {
    setPage(v)
    const params: Req.ProjectParams = {
      page: v,
      pageSize: pageSize.current,
      businessType: filterParams?.businessType || "",
      projectCategory: filterParams?.projectCategory || "",
      projectBigStage: filterParams?.projectBigStage || "",
      companyCode: filterParams?.companyCode || "",
      deptCode: filterParams?.deptCode || "",
      keyword: filterParams?.keyword || "",
      sort: tableOrder

      // pageSize: pageSize.current,
      // offset: v,
      // filters: JSON.stringify([
      //   {
      //     "active": { "operator": "=", "values": ["t"] }
      //   }
      // ]),
      // sortBy: JSON.stringify([["id", "desc"]]),
    }
    fetchProjects(params)
  }
  useEffect(() => {
    onPageChange(1)
  }, [])

  useEffect(() => {
    const handleSuccess = () => {
      refresh();
    };
    window.addEventListener(PpmProjectListRefreshEventName, handleSuccess);
    return () => {
      window.removeEventListener(PpmProjectListRefreshEventName, handleSuccess);
    };
  }, [refresh]);

  const handleUpdate = (id: number, fields?: string[]) => {
    dispatchPpmProjectUpdateModalOpenEvent({ id, fields });
  };
  const onFollow = async (v: API.PROJECT.Info) => {
    await followPMProjectApi(v.code)
    refresh()
  }
  const handleTableChange: TableProps<API.PROJECT.Info>['onChange'] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    if(extra.action !== "sort") return
    if (sorter instanceof Array) {
      let sort: string[] = []
      sorter.forEach(v => {
        if (v.columnKey === "code") {
          sort.push(v.order === "ascend" ? "project_code" : "-project_code")
        } else if (v.columnKey === "name") {
          sort.push(v.order === "ascend" ? "project_name" : "-project_name")
        }
      })

      const sortStr = sort.join(",")
      setTableOrder(sortStr)
    } else {
      if (!sorter.order) {
        setTableOrder("")
        return
      }
      let sortStr = ""
      if (sorter.columnKey === "code") {
        sortStr = sorter.order === "ascend" ? "project_code" : "-project_code"
      } else if (sorter.columnKey === "name") {
        sortStr = sorter.order === "ascend" ? "project_name" : "-project_name"
      }
      setTableOrder(sortStr)
    }
  }
  const tableColumns: TableProps<API.PROJECT.Info>['columns'] = [
    {
      key: 'code',
      dataIndex: 'code',
      title: '项目编号',
      width: 120,
      sorter: true,
      showSorterTooltip: false,
      className: 'group-hover:bg-inherit',
      render: (text, record) => {
        return <Space>
            <Button className="px-1 text-[20px]" type="text" onClick={() => onFollow(record)}>
            {record.isFollow ? <FollowedSvg /> : <AddFollowSvg />}
            </Button>
          {text}
        </Space>

        // if (!record.profile) return null;
        // return (
        //   <div>
        //     <span>{text}</span>
        //     {record.canUpdate && (
        //       <EditOutlined
        //         className="text-blue-400 cursor-pointer ml-2 transition-all  opacity-0 group-hover:opacity-100"
        //         title="编辑"
        //         onClick={() => handleUpdate(record.id, ['code', 'name'])}
        //         data-report="click"
        //         data-report-name="clickEditPpmProjectCodeButton"
        //         data-report-title="点击编辑项目编号按钮"
        //         data-report-position="项目列表"
        //       />
        //     )}
        //   </div>
        // );
      },
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '项目名称',
      width: 300,
      sorter: true,
      showSorterTooltip: false,
      className: 'group-hover:bg-inherit',
      render: (name, record) => {
        if (!name) return null;
        // if (record.opProjectID > 0) {
        //   return (
        //     <Link
        //       to={generatePath('/projects/:projectID/dashboard', { projectID: record.opProjectID.toString() })}
        //       className="hover:underline text-inherit"
        //     >
        //       <Typography.Text>
        //         {name}
        //       </Typography.Text>
        //     </Link>
        //   );
        // }
        return name
      },
    },
    {
      key: 'projectManager',
      dataIndex: 'projectManager',
      title: '项目经理',
      width: 120,
      className: 'group-hover:bg-inherit',
    },
    {
      key: 'projectCreators',
      dataIndex: 'projectCreators',
      title: '设总/主创',
      width: 120,
      className: 'group-hover:bg-inherit',
    },
    {
      key: "action",
      title: '管理',
      width: 200,
      align: 'left',
      className: 'group-hover:bg-inherit',
      render: (_, record) => {
        const items = [];
        const ddsItem = record.ddsLink ?
          (<a
            href={record.ddsLink}
            target='_blank'
            rel='noreferrer'
            key="dds"
            onClick={onIthAnchorClick}
          >
            <Button
              className="px-0 tracking-wide"
              type="text"
              style={{ color: '#413974' }}
            >
              DDS
            </Button>
          </a>) : (
            <Tooltip title="该项目没有创建DDS文件夹">
              <span
                key="dds"
                className="px-0 tracking-wide"
                style={{ color: '#a1a1a1' }}
              >
              DDS
              </span>
            </Tooltip>)
        items.push(ddsItem)
        
        const plmItem = record.opProjectID > 0 ? (
          <a
            href={documentUtil.getPpmProjectPath(record.opProjectID)}
            target='_blank'
            rel='noreferrer'
            key="plm"
            onClick={onIthAnchorClick}
          >
            <Button className="p-0" type="text">
              <img
                style={{ height: 20 }}
                src={ppmLogo}
                alt=""
              />
            </Button>
          </a>
        ) : (
            <Tooltip title="该项目没有创建PLM项目空间">
              <span key="plm" className="p-0 opacity-25">
                <img
                  style={{ height: 20 }}
                  src={ppmLogo}
                  alt=""
                />
              </span>
            </Tooltip>
        )

        items.push(plmItem)

        if (record.isBoutique) {
          items.push((
            <a
              href={`https://km.thape.com.cn:8022/wcm/tianhua/projectdetails?projectitemcode=${record.code}`}
              target='_blank'
              rel='noreferrer'
              key="pm"
              onClick={onIthAnchorClick}
            >
              <Button className="px-1" type="text">
                精品
              </Button>
            </a>
          ))
        }
        
        return (
          <Space size="large">
            {items}
          </Space>
        );
      },
    },
  ];

  return (
    <div>
      <IthHelmet pageTitle="项目" report />
      <Card
        // title="项目看板"
        // extra={(
        //   <Space>
        //     <Link to="/projects/new">
        //       <Button
        //         type="primary"
        //         data-report="click"
        //         data-report-name="clickCreateProjectButton"
        //         data-report-title="点击创建项目空间按钮"
        //         data-report-position="项目列表上方"
        //       >
        //         创建项目空间
        //       </Button>
        //     </Link>
        //   </Space>
        // )}
      >
        <ProjectHeader onChange={onFilterParamsChange} />
        <Table
          loading={loading}
          tableLayout="fixed"
          rowKey="code"
          columns={tableColumns}
          dataSource={data?.list}
          pagination={false}
          className={`${styles.ppmTable}`}
          onChange={handleTableChange}
          rowClassName="even:bg-gray-50 odd:bg-white hover:shadow-eq hover:scale-100 transition-shadow duration-300 group"
          locale={{
            emptyText: (
              <ThEmpty
                description={(
                  <div className="text-black/50 mt-4">
                    {!loading && (
                      <div>
                        {/* 这里是一片信息的荒漠，快邀请团队来 */}
                        {/* <Link to="/projects/new">
                          <Button
                            className="px-1"
                            type="link"
                            size="small"
                            data-report-name="clickCreateProjectButton"
                            data-report-title="点击创建项目空间按钮"
                            data-report-position="项目列表Empty区域"
                          >
                            创建项目空间
                          </Button>
                        </Link>
                        吧！ */}
                      </div>
                    )}
                  </div>
                )}
              />
            ),
          }}
        />
      </Card>
      <Card>
        <Pagination current={page} onChange={(v) => onPageChange(v)} total={data?.total} pageSize={pageSize.current} onShowSizeChange={(cur, size) => {
          pageSize.current = size
        }
        } />
      </Card>
    </div>
  );
};

export default ProjectList;
